import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    this.thumbnailGallery = new Swiper('.thumbnail-container', {
      direction: 'vertical',
      loop: true,
      loopAdditionalSlides: 3,
      slideToClickedSlide: true,
      height: 134
    });

    this.fullGallery = new Swiper('.gallery-container', {
      loop: false,
      height: 134
    });

    let _this = this;
    // realIndex ignores the slides Swiper duplicates for looping, so both galleries
    // share one index space.
    this.thumbnailGallery.on('slideChange', function () {
      _this.syncSliders(_this.thumbnailGallery.realIndex);
    });

    this.fullGallery.on('slideChange', function () {
      _this.syncSliders(_this.fullGallery.activeIndex);
    });

    refreshFsLightbox();
  }

  // The guards stop the two slideChange handlers bouncing the sync back and forth.
  syncSliders(index) {
    if (this.fullGallery.activeIndex != index) {
      this.fullGallery.slideTo(index);
    }

    if (this.thumbnailGallery.realIndex != index) {
      this.thumbnailGallery.slideToLoop(index);
    }
  }

  // The arrows drive the full gallery only; syncSliders pulls the thumbnails along.
  galleryPrev() {
    if (this.fullGallery.isBeginning) {
      this.fullGallery.slideTo(this.fullGallery.slides.length - 1);
    } else {
      this.fullGallery.slidePrev();
    }
  }

  galleryNext() {
    if (this.fullGallery.isEnd) {
      this.fullGallery.slideTo(0);
    } else {
      this.fullGallery.slideNext();
    }
  }

}
